import { Injectable } from '@angular/core';

import { ConfigBaseService } from '../../core/config/config-base.service';

@Injectable({
  providedIn: 'root'
})
export class SecuriteConfigService extends ConfigBaseService {
  useHash: boolean;
  baseHref: string;
  authApiEndPoint: string;

  get authApiPresent(): boolean {
    return this.authApiEndPoint && this.authApiEndPoint.length > 0;
  }

  constructor() {
    super();
  }
}
